export default () => ({
  charts: {
    paddingBottom: 2,
    marginBottom: 34,
  },
});
